<template>
    <section id="step-2">
        <form action="">

            <div
                id="click-is-company"
                class="pt-2">
                <Checkbox
                    :id="'is-company'"
                    :name="'payer_type'"
                    :checkedValue="true"
                    :value="payerType"
                    @change="payerType = $event"
                    :text="'Wpłacam jako firma'"/>
            </div>

            <div class="row small-gutters personal-data">
                <div class="col-6">
                    <div class="form-group">
                        <AInput
                            :tag="'input'"
                            v-model="firstName"
                            :type="'text'"
                            :name="'first_name'"
                            v-validate="validationRules.standardValidation"
                            :placeholder="' '"
                            :label="'Imię *'"/>
                        <Error :fieldName="'first_name'"/>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <AInput
                            :tag="'input'"
                            v-model="lastName"
                            :type="'text'"
                            :name="'last_name'"
                            v-validate="validationRules.standardValidation"
                            :placeholder="' '"
                            :label="'Nazwisko *'"/>
                        <Error :fieldName="'last_name'"/>
                    </div>
                </div>
            </div>
            <div class="row small-gutters email">
                <div class="col-12">
                    <div class="form-group">
                        <AInput
                            :tag="'input'"
                            v-model="mailInput"
                            :type="'text'"
                            :name="'email'"
                            v-validate="validationRules.emailValidation"
                            data-vv-validate-on="change"
                            :placeholder="' '"
                            :label="'E-mail *'"
                        />
                        <Error :fieldName="'email'"/>
                    </div>
                </div>
            </div>
            <div
                class="row small-gutters company"
                v-show="isCorporate"
            >
                <div class="col-12">
                    <div class="form-group">
                        <AInput
                            :tag="'input'"
                            v-model="corporateName"
                            :type="'text'"
                            :name="'corporate_name'"
                            v-validate="isCorporate ? validationRules.simpleValidation : ''"
                            :placeholder="' '"
                            :label="'Nazwa firmy / instytucji *'"/>
                        <Error :fieldName="'corporate_name'"/>
                    </div>
                </div>
            </div>
            <div class="row small-gutters vat-id">
                <div
                    class="col-6"
                    v-show="isCorporate"
                >
                    <div class="form-group company">
                        <AInput
                            :tag="'input'"
                            v-model="taxId"
                            :type="'text'"
                            :name="'tax_id'"
                            v-validate="isCorporate ? validationRules.nipValidation : ''"
                            :placeholder="' '"
                            :label="'NIP *'"/>
                        <Error :fieldName="'tax_id'"/>
                    </div>
                </div>
            </div>
            <div
                class="row small-gutters address"
                v-show="isCorporate || isPaymentByCard"
            >
                <div class="col-12">
                    <div class="form-group">
                        <AInput
                            :tag="'input'"
                            v-model="streetAddress"
                            :type="'text'"
                            :name="'street_address'"
                            v-validate="isCorporate || isPaymentByCard ? validationRules.simpleValidation : ''"
                            :placeholder="' '"
                            :label="'Adres *'"/>
                        <Error :fieldName="'street_address'"/>
                    </div>
                </div>
            </div>
            <div
                class="row small-gutters address"
                v-show="isCorporate || isPaymentByCard"
            >
                <div class="form-group col-md-5 col-6 col-sm-6">
                    <AInput
                        :tag="'input'"
                        v-model="postalCode"
                        :type="'text'"
                        :name="'postal_code'"
                        v-validate="isCorporate || isPaymentByCard ? validationRules.postalCodeValidation : ''"
                        :placeholder="' '"
                        :label="'Kod pocztowy *'"/>
                    <Error :fieldName="'postal_code'"/>
                </div>
                <div class="form-group col-md-7 col-6 col-sm-6">
                    <AInput
                        :tag="'input'"
                        v-model="city"
                        :type="'text'"
                        :name="'city'"
                        v-validate="isCorporate || isPaymentByCard ? validationRules.standardValidation : ''"
                        :placeholder="' '"
                        :label="'Miasto *'"/>
                    <Error :fieldName="'city'"/>
                </div>
            </div>

            <div id="consents-list">
                <ul>
                    <li
                        v-for="(consent, index) in consents"
                        :key="index">
                        <ConsentList :index="index" :consent="consent" @input="saveConsentToSession($event)"/>
                    </li>
                </ul>
            </div>

            <div class="current-amount-plus-next-btn">
                <current-amount :amount="this.$store.state.currentAmount" />

                <div
                    class="button-next pb-3 mb-4">
                    <NextButton @click="sendForm" :isDisabled="formSending">
                        <span v-html="nextButtonText"></span>
                    </NextButton>
                </div>
            </div>

            <SafePayment />
        </form>
    </section>
</template>

<script>
import NextButton from "@/components/atoms/NextButton.vue";
import SafePayment from "@/components/atoms/SafePayment.vue";
import { validationRules } from "@/helpers/validationRules";
import Consents from "@SYSTEM_CONSENTS";
import StripeConsents from '@SYSTEM_CONSENTS_STRIPE';
import { connectToSession } from "@/helpers/connectToSession";
import syncVuexWithSessionStorage from "@/mixins/syncVuexWithSessionStorage.vue";
import CurrentAmount from "@/components/atoms/CurrentAmount.vue";
import Checkbox from "@/components/atoms/Checkbox.vue";
import AInput from "@/components/atoms/AInput.vue";
import Error from "@/components/atoms/Error.vue";
import ConsentList from "@/components/molecules/ConsentList.vue";
import {PaymentEndpointResolver} from "@/helpers/paymentEndpointResolver";
import axios from "axios";
import qs from "qs";
import paymentMethods from "@/constants/paymentMethods";
import paymentMethodBinding from "@/constants/paymentMethodBinding";
import systemConst from "@SYSTEM_CONSTANTS";
import Cookies from "js-cookie";
import {mapGetters} from "vuex";

export default {
    name: 'CommonSecondStepForm',
    inject: ['$validator'],
    props: [
        'paymentType',
    ],
    mixins: [syncVuexWithSessionStorage],
    components: {
        ConsentList,
        Error, AInput,
        Checkbox,
        CurrentAmount,
        SafePayment,
        NextButton,
    },
    data () {
        return {
            validationRules,
            paymentMethods,
            formSending: false,
            formData: {},
        }
    },
    mounted () {
        this.syncVuexWithSessionStorage();

        this.consentDetails();

        this.consents.forEach((consent) => {
            if (window.sessionStorage.getItem(consent.name) == null) {
                sessionStorage.setItem(consent.name, 'false')
            }
        })

        if (window.sessionStorage.getItem('payer_type') == null) {
            sessionStorage.setItem('payer_type', 'individual')
        }
    },
    computed: {
        ...mapGetters([
            'currentMethod',
        ]),
        firstName: { ...connectToSession.setNames('firstName', 'first_name') },
        lastName: { ...connectToSession.setNames('lastName', 'last_name') },
        mailInput: { ...connectToSession.setNames('email', 'email') },
        payerType: {
            get () {
                return this.$store.state.payerType === 'corporate'
            },
            set (newValue) {
                if (newValue.target.value !== 'true') {
                    this.$store.commit('setPayerType', 'corporate')
                    sessionStorage.setItem('payer_type', 'corporate')
                } else {
                    this.$store.commit('setPayerType', 'individual')
                    sessionStorage.setItem('payer_type', 'individual')
                }
            }
        },
        corporateName: { ...connectToSession.setNames('corporateName', 'corporate_name') },
        taxId: { ...connectToSession.setNames('taxId', 'tax_id') },
        streetAddress: { ...connectToSession.setNames('streetAddress', 'street_address') },
        postalCode: { ...connectToSession.setNames('postalCode', 'postal_code') },
        city: { ...connectToSession.setNames('city', 'city') },
        isCorporate() {
            return this.payerType
        },
        isPaymentByCard() {
            return this.currentMethod === paymentMethods.CARD
        },
        nextButtonText() {
            if (this.currentMethod === paymentMethods.DRUK) {
                return 'Przechodzę dalej  &gt;';
            }

            return 'Przechodzę do płatności  &gt;';
        },
        isCardSubscription() {
          return paymentMethods.CARD === this.currentMethod;
        },
        consents() {
          if (true === this.isCardSubscription) {
            return StripeConsents;
          }

          return Consents;
        }
    },
    methods: {
        consentDetails () {
            let showDetails = document.getElementById('showDetails')
            let hideDetails = document.getElementById('hideDetails')
            let details = document.getElementById('details')

            showDetails.addEventListener('click', function (event) {
                event.preventDefault()

                details.classList.remove('d-none')
                details.classList.add('d-block')

                showDetails.classList.add('invisible')
            })
            hideDetails.addEventListener('click', function (event) {
                event.preventDefault()

                showDetails.classList.remove('invisible')

                details.classList.remove('d-block')
                details.classList.add('d-none')
            })
        },
        saveConsentToSession (data) {
            sessionStorage.setItem(data[0], data[1])
        },
        nextStep (e) {
            connectToSession.dataToSessionStorage(
                this.currentAmount,
                this.$store.state.amountList,
                this.paymentType,
                this.$store.state.paymentMethod,
                process.env.VUE_APP_PAYMENT_FORM_NAME,
                process.env.VUE_APP_SUCCESS_URL,
                process.env.VUE_APP_FAILURE_URL,
                process.env.VUE_APP_SUCCESS_DIRECT_URL,
                (new URLSearchParams(window.location.search)).get('partner'),
            )
            this.$validator.validate().then(result => {
                if (result === true) {
                    // moving to next step
                }
            })
        },
        prepareData () {
            for (let i = 0; i < sessionStorage.length; i++) {
                this.formData[sessionStorage.key(i)] = sessionStorage.getItem(sessionStorage.key(i))
            }
        },
        axiosSend () {
            let endpointResolver = new PaymentEndpointResolver()

            axios.post(endpointResolver.resolve(), qs.stringify(this.formData), {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
            .then(function (response) {
                if (response.data.redirect_url != null) {
                    window.location.replace(response.data.redirect_url)
                }
            })
            .catch((error) => {
                if (error) {
                    this.formSending = false
                }
            })
        },
        GTMdataLayerCookieUpdate () {
            let DataLayer = {}
            DataLayer.price = this.formData['amount']

            let payments = {
                key1: {
                    conditions: {
                        gateway: paymentMethods.CARD,
                        type: 'subscription'
                    },
                    data: {
                        sku: systemConst.KEY1_SKU,
                        name: process.env.VUE_APP_SYSTEM + '_wplata_karta'
                    }
                },
                key2: {
                    conditions: {
                        gateway: paymentMethods.ONLINE,
                        type: 'single'
                    },
                    data: {
                        sku: systemConst.KEY2_SKU,
                        name: process.env.VUE_APP_SYSTEM + '_wplata'
                    }
                },
                key3: {
                    conditions: {
                        gateway: paymentMethods.DRUK,
                        type: 'subscription'
                    },
                    data: {
                        sku: systemConst.KEY3_SKU,
                        name: process.env.VUE_APP_SYSTEM + '_wplata_wip_tradycyjna'
                    }
                },
                key4: {
                    conditions: {
                        gateway: paymentMethods.DRUK,
                        type: 'single'
                    },
                    data: {
                        sku: systemConst.KEY4_SKU,
                        name: process.env.VUE_APP_SYSTEM + '_wplata_tradycyjna'
                    }
                },
                key5: {
                    conditions: {
                        gateway: paymentMethods.BLIK,
                        type: 'single'
                    },
                    data: {
                        sku: systemConst.KEY5_SKU,
                        name: process.env.VUE_APP_SYSTEM + '_wplata_blik'
                    }
                }
            }
            for (let key in payments) {
                if (this.formData['payment_gateway'] === payments[key].conditions.gateway && this.formData['payment_type'] === payments[key].conditions.type) {
                    DataLayer.sku = payments[key].data.sku
                    DataLayer.name = payments[key].data.name
                }
            }

            Cookies.set('wplatomat_dataLayer', DataLayer.price + '|' + DataLayer.sku + '|' + DataLayer.name, { expires: 1 })
        },
        sendForm () {
            this.formSending = true
            this.prepareData()
            this.GTMdataLayerCookieUpdate()

            this.$validator.validateAll().then(result => {

                if (result === true) {
                    sessionStorage.setItem('valid_payment_form', '1')
                    this.axiosSend()
                } else {
                    this.formSending = false
                    const firstErrorElement = document.getElementsByName(this.errors.items[0].field)[0]
                    firstErrorElement.scrollIntoView()
                }
            })
        },
        isValidPaymentMethod (currentMethod, paymentType) {
            return paymentMethodBinding.isValid(currentMethod, paymentType)
        },
    },
    created() {
        let currentAmount = this.$store.state.currentAmount;

        if (currentAmount === undefined || typeof(currentAmount) === 'undefined' || currentAmount === 'undefined') {
            this.$router.push('/')
        }

        let paymentMethod = this.$store.state.paymentMethod;

        if (typeof(paymentMethod) === 'undefined' || paymentMethod === 'undefined') {
            this.$router.push('/')
        }

        if (!this.isValidPaymentMethod(paymentMethod, this.paymentType)) {
            if (this.paymentType === 'subscription') {
                this.$router.push('/co-miesiac/')
            } else {
                this.$router.push('/')
            }
        }
    }
}
</script>
